import React, { use, useEffect, useState } from "react";
import { Avatar, Box, Button, Stack } from "@mui/material";
import Grid from "@mui/material/Grid2";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import AddIcon from "@mui/icons-material/Add";
import { Typography } from "antd";
import LoginPageLogo from "../../assets/images/LoginPageLogo.png";
import { Padding } from "@mui/icons-material";
import Styles from "./FeedbackForm.module.scss";
import { useLocation, useNavigate } from "react-router-dom";
import {
  getProjectByToken,
  updateProjectResponse,
} from "../../services/feedbackForm.service";
import dayjs from "dayjs";
const FeedbackSkip = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dataReceived = location.state;


  const handleSubmit = async () => {
    try {
      const feedbackData = {
        status: "2",
        upComingSurveyDate:dayjs(dataReceived?.upComingSurveyDate).add(dataReceived?.surveyInterval, 'month').toISOString()
      };
      const res = await updateProjectResponse(
        dataReceived?.transId,
        feedbackData
      );

      console.log(res, "res");
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    handleSubmit();
  }, []);

  return (
    <Box>
      {/* Header */}
      <Box className={Styles.Container}>
        <Typography
          style={{
            color: "white",
            fontSize: "24px",
            fontWeight: 700,
            marginLeft: "3%",
          }}
        >
          WSH
        </Typography>
        <Stack
          direction={"row"}
          sx={{
            justifyContent: "center",
            alignItems: "center",
            mr: "1%",
          }}
        >
          <Box
            sx={{
              position: "relative",
              display: "flex",
              alignItems: "center",
            }}
          >
            {/* Avatar component */}
            <Avatar
              sx={{
                height: "40px",
                // width: "40px",
                background: "white",
                color: "#00675d",
                paddingLeft: "10px", // Add space for the text
                paddingRight: "10px",
                marginRight: "-5px", // Negative margin to move Box to the right
                zIndex: 1, // Ensure Avatar is on top
              }}
            >
              {dataReceived?.contactName?.charAt(0)}
            </Avatar>
            {/* Box component */}
            <Box
              sx={{
                background: "#FFFFFF33",
                borderRadius: 5,
                height: "40px",
                width: "200px",
                maxWidth: "150px",
                color: "white",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                textAlign: "center",
                marginLeft: "-13%",
                zIndex: 2,
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              <Typography style={{ paddingLeft: "7%", color: "white" }}>
                {dataReceived?.contactName?.length > 10
                  ? `${dataReceived?.contactName?.slice(0, 10)}...`
                  : dataReceived?.contactName}
              </Typography>
            </Box>
          </Box>
        </Stack>
      </Box>

      {/* Content */}
      <Stack className={Styles.Content}>
        <img src={LoginPageLogo} alt="Company Logo" style={{ width: 147 }} />
        <Typography className={Styles.Welcome}>
          {/* Welcome {data?.contactName}! */}
        </Typography>
        <Typography
          style={{
            fontWeight: 600,
            fontSize: "22px",
            fontFamily: "Open Sans, sans-serif",
          }}
        >
          Feedback Skipped
        </Typography>

        <Typography
          style={{
            fontWeight: 400,
            fontSize: "18px",
            alignItems: "center",
            color: "#000000",
            padding: "0px 20px",
            fontFamily: "Open Sans, sans-serif",
          }}
        >
          If you change your mind, feel free to share your feedback anytime to
          help us improve
        </Typography>
      </Stack>
    </Box>
  );
};

export default FeedbackSkip;
